module.exports = __webpack_public_path__ + "img/mission-good-for-the-planet.jpg?bd1750d3d3d5af4422a6ed9e7a7c5ee1";